import { numberToArray, pluralize } from '../../Helper';

export const textCategory = {
  LARGE_HEADING: 'h4',
  HEADING: 'h6',
  TITLE: 's1',
  BODY: 'p1',
  SMALL_BODY: 'p2',
  XSMALL_BODY: 'c1',
};

export const formikNames = {
  ADDONS: 'addOns',
  DIETARYORALLERGY: 'dietaryOrAllergy',
  CELEBRATIONS: 'celebrations',
};

export const defaultPartySizes = numberToArray(16).map((e) => {
  const count = e + 1;
  return {
    label: `${count} ${pluralize(count, 'guest')}`,
    value: count,
  };
});

export enum modalType {
  CELEBRATIONS = 'celebrations',
  DIETARYORALLERGY = 'dietaryOrAllergy',
}
